module.exports = __webpack_public_path__ + "img/image-04.3e891a8e.webp";